import React from 'react';

import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import useExperimentTags, {
  ExperimentTagData
} from '@shared/hooks/useExperimentTags';
import useShowRemainingContent from '@/helpers/custom-hooks/useShowRemainingContent';
import ExperimentTag from '../ExperimentTag';
import RemainingTags from './RemainingTags';

type ResizableExperimentTagListProps = {
  row: {
    tags: string[];
    experimentKey: string;
  };
  isDeleteDisabled?: boolean;
};

const ResizableExperimentTagList: React.FC<ResizableExperimentTagListProps> = ({
  row,
  isDeleteDisabled = false
}) => {
  const experimentTagList = useExperimentTags({
    filteredList: row.tags
  });

  const { containerRef, shouldShowRemainingContent } = useShowRemainingContent(
    map(experimentTagList, 'name')
  );

  if (!experimentTagList.length || isEmpty(row.tags) || !isArray(row.tags))
    return null;

  const renderExperimentTag = (tag: ExperimentTagData) => (
    <ExperimentTag
      key={tag.name}
      tagName={tag.name}
      tagColor={tag.color}
      experimentKey={row.experimentKey}
      isDeleteDisabled={isDeleteDisabled}
    />
  );

  return (
    <div
      ref={containerRef}
      className="tag-row-container column-tag-list"
      onClick={e => e.stopPropagation()}
    >
      {experimentTagList.map(renderExperimentTag)}

      {shouldShowRemainingContent && (
        <RemainingTags>
          {experimentTagList.map(renderExperimentTag)}
        </RemainingTags>
      )}
    </div>
  );
};

export default React.memo(ResizableExperimentTagList);
